import _ from 'lodash'
import BaseViewModel from '../../../infraestructure/BaseViewModel'
import CourseCategory from '../models/CourseCategory'

export default class CourseCategoryViewModel extends BaseViewModel {
  constructor(view) {
    super(view)
  }
  // INICIALIZADORES

  //#region CRUD

  onCreate() {
    let item = new CourseCategory({
      state: "create",
      status: 1
    });
    return item;
  }

  onDelete(data) {
    let item = new CourseCategory(data);
    item.state = "delete";
    return item;
  }

  onEdit(data) {
    let item = new CourseCategory(data);
    item.state = "update";
    return item;
  }

  onSearchCollection() {
    return this.api.courseCategories.find(this.getSearchQuery())
  }

  mapCollection(collection) {
    return _.map(collection, (data) => new CourseCategory(data));
  }

  onSearchItem(id) {
    return this.api.courseCategories.findOne(id)
  }

  onSave(data) {
    if (data.state === 'create')
      return this.api.courseCategories.create(data.toSend())
    else
      return this.api.courseCategories.update(data.id, data.toSend());
  }

  onDestroy(context, id) {
    context.api.courseCategories.delete(id)
        .then(response => context.view.onSuccess(response.data))
        .catch(context.view.onError)
}

  onCancel(context) {
    context.view.item = null;
  }

  import(file) {
    this.api.courseCategories.import(file)
      .then(response => this.view.onImportResponse(response.data))
      .catch(this.view.onError)
  }

  exportToExcel() {
    this.api.courseCategories.exportToExcel()
      .then(response => this.view.onExportResponse(response.data))
      .catch(this.view.onError)
  }

  // #endregion

  // #region BINDING DATA

  bindFormView() {
    if (this.view.formData.state === 'update') {
      if (!_.isEmpty(this.view.formData.parent)) {
        this.view.parents = [this.view.formData.parent]
      }
    }
    setTimeout(() => {
      this.showModalLoading(this.view.conf, false);
    }, 400);
  }

  // #endregion

  // #region QUERIES

  /**
   * Metodo para buscar categorias de cursos
   * @param {String} data Query string para parametros de búsqueda
   */
  findCourseCategories(data) {
    this.api.courseCategories.find(data)
      .then((response) => this.view.onSearchCourseCategoriesResponse(response.data.data))
      .catch(this.view.onError)
  }
  

  // #endregion

  //#region MAPPING DATA

  
  // #endregion

  // #region VALIDATIONS

  // #endregion
}
